// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import DesShareLibrarySearchBox from 'viewmodel/DesShareLibrarySearchBoxViewModel';
import DesShareLibrarySearchResultsForUsers from 'viewmodel/DesShareLibrarySearchResultsForUsersViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "selectedUsers": null
    },
    "lifecycleHooks": {
        "onMount": {
            "action": "setCustomAttribute"
        },
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.libraryid",
                "props.emailtemplateid",
                "props.emailtemplateparams",
                "props.collaborationspaceid"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        },
        "emailtemplateid": {
            "type": "string"
        },
        "emailtemplateparams": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "actions": {
        "shareLibrary": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "selectedUsers": "{{data.selectedUsers}}",
                            "libraryId": "{{props.libraryid}}"
                        },
                        "query": "mutation AddMembersToLibrary( $addMembersToLibraryInput: Json) {addMembersToLibrary( addMembersToLibraryInput: $addMembersToLibraryInput) }",
                        "variables": {
                            "AddMembersToLibraryInput": {
                                "libraryId": "{{props.libraryid}}",
                                "emailTemplateId": "{{props.emailtemplateid}}",
                                "emailTemplateParams": "{{props.emailtemplateparams}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accSessionId": "{{props.accsessionid}}"
            },
            "outputData": {
                "sharedUser": "data.data.addMembersToLibrary",
                "error": "data.data.addMembersToLibrary"
            },
            "events": {
                "success": [
                    {
                        "name": "shareLibraryToUsersSuccess",
                        "eventData": {
                            "eventName": "shareLibraryToUsersSuccess",
                            "eventData": "{{sharedUser}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayShareLibrarySuccessMsg"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "subscribeUsersEventAction": {
            "actionType": "JSFunction",
            "method": "storeUserData",
            "inputData": {
                "data": "{{data}}",
                "selectedUsers": "{{parameters.eventData}}"
            },
            "deps": "js/desUpdateLibraryService"
        },
        "setCustomAttribute": {
            "actionType": "JSFunction",
            "method": "setCustomAttribute",
            "deps": "js/desUpdateLibraryService"
        }
    },
    "messages": {
        "displayShareLibrarySuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.shareLibrarySuccessMsg}}"
        }
    },
    "onEvent": [
        {
            "eventId": "shareLibraryToUsersSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "shareLibraryToUsersSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "selectedUsersSuccess",
            "action": "subscribeUsersEventAction",
            "inputArgs": {
                "eventName": "selectedUsersSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "i18n": {
        "users": [
            "DesLibraryMessages"
        ],
        "teams": [
            "DesLibraryMessages"
        ],
        "shareButton": [
            "libraryMessages"
        ],
        "searchUsersString": [
            "DesLibraryMessages"
        ],
        "searchTeamsString": [
            "DesLibraryMessages"
        ],
        "shareLibrarySuccessMsg": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesShareLibraryToUsers",
    "_uniqueViewModelId": "DesShareLibraryToUsers",
    "ctx": {}
};

    /*
    <aw-panel>
    <des-share-library-search-box accsessionid={{props.accsessionid}}></des-share-library-search-box>
    <des-share-library-search-results-for-users accsessionid={{props.accsessionid}} libraryid={{props.libraryid}}
        collaborationspaceid="{{props.collaborationspaceid}}"></des-share-library-search-results-for-users>
    <aw-panel-footer>
        <aw-button class='small' button-type='accent-high-contrast' size='stretched'
            action='shareLibrary'>{{i18n.shareButton}}
        </aw-button>
    </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <DesShareLibrarySearchBox accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        </DesShareLibrarySearchBox>
        <DesShareLibrarySearchResultsForUsers accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} libraryid={AwParseService.instance( "props.libraryid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} collaborationspaceid={AwParseService.instance( "props.collaborationspaceid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        </DesShareLibrarySearchResultsForUsers>
        <AwPanelFooter>
            <AwButton className="small" buttonType="accent-high-contrast" size="stretched" action={actions.shareLibrary}>
                {AwParseService.instance( "i18n.shareButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButton>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;